/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/pages/movatic-dev/MovaticDevIndex.tsx
 * ----------------------------------------------------------------------------
 * Movatic DEV — pagina-indice (casca, ADR-0042).
 *
 * INERTE: so' JSX estatico, ZERO chamadas a API. As telas reais (criar ordem
 * parametrizada; catalogo visual) sao fatias futuras. A seguranca real e' o
 * backend (D3 IsSuperuser + D5 is_sandbox); esta tela so' descreve o modulo.
 * ========================================================================== */

import {
  FlaskConical,
  ShoppingCart,
  Package,
  AlertTriangle,
} from 'lucide-react'
import { Link } from 'react-router-dom'

export default function MovaticDevIndex() {
  return (
    <div className="p-4 md:p-6 space-y-6">
      {/* Cabecalho */}
      <div className="flex items-center gap-3">
        <FlaskConical className="w-7 h-7 opacity-80" />
        <div>
          <h1 className="text-2xl font-semibold leading-tight">Movatic DEV</h1>
          <div className="text-xs font-mono opacity-60">
            T-code DV — catálogo + gatilhos de demo/teste
          </div>
        </div>
      </div>

      {/* Aviso: opera a serio */}
      <div className="flex items-start gap-3 rounded-xl border p-4 text-sm">
        <AlertTriangle className="w-5 h-5 mt-0.5 shrink-0 opacity-80" />
        <div className="space-y-1">
          <div className="font-medium">Este módulo opera a sério.</div>
          <p className="opacity-70">
            O Movatic DEV injeta ordens reais (venda, compra, copacking) e move
            stock de verdade — é o próprio motor a correr, não uma simulação.
            Por isso só é acessível a <strong>superusuários</strong> e só atua
            contra warehouses marcados como <strong>sandbox</strong>
            (fail-closed). Repor stock faz-se pela operação real (comprar),
            nunca por restore.
          </p>
        </div>
      </div>

      {/* Cartoes das areas */}
      <div className="grid gap-4 sm:grid-cols-2 max-w-3xl">
        <Link
          to="/movatic-dev/criar"
          className="rounded-xl border p-4 space-y-2 block hover:bg-black/5 transition-colors"
        >
          <div className="flex items-center gap-2">
            <ShoppingCart className="w-5 h-5 opacity-80" />
            <span className="font-medium">Criar ordem</span>
            <span className="ml-auto text-[11px] rounded-full border border-sky-500/50 px-2 py-0.5 text-sky-600">
              Abrir →
            </span>
          </div>
          <p className="text-sm opacity-70">
            Gera o gatilho do cenário (cliente + produto + quantidade) em lote e
            deixa o sistema reagir. Dispara X clientes e vê a reação por ordem.
          </p>
        </Link>

        <Link
          to="/movatic-dev/catalogo"
          className="rounded-xl border p-4 space-y-2 block hover:bg-black/5 transition-colors"
        >
          <div className="flex items-center gap-2">
            <Package className="w-5 h-5 opacity-80" />
            <span className="font-medium">Catálogo</span>
            <span className="ml-auto text-[11px] rounded-full border border-sky-500/50 px-2 py-0.5 text-sky-600">
              Abrir →
            </span>
          </div>
          <p className="text-sm opacity-70">
            Mostrador de execução: escolhe um operador e a tela segue a task
            ativa dele — os candidatos do passo, com código escaneável. O
            operador pica com o coletor (a tela não tem ações).
          </p>
        </Link>
      </div>

      {/* A caminho */}
      <div className="max-w-3xl space-y-2">
        <div className="text-sm font-medium opacity-80">A caminho</div>
        <ul className="text-sm opacity-70 list-disc pl-5 space-y-1">
          <li>
            Tela de venda (cliente + produto + qty → dispara o ciclo real).
          </li>
          <li>
            Tela de compra (fornecedor + produto + qty + ETA → repõe stock).
          </li>
          <li>
            Catálogo visual + anti-fraude (3 imagens: 1 correta, 2 iscas).
          </li>
        </ul>
      </div>
    </div>
  )
}
